import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpLoaderService } from '@tymes4-shared';
import { finalize } from 'rxjs/operators';
import { EventPlacementService } from '../../api';
import { GenericErrorHandler } from '../../helpers/generic-error-handler';

@Component({
    selector: 'app-edit-unplaced-event-capacity',
    templateUrl: './edit-unplaced-event-capacity.component.html',
    styleUrls: ['./edit-unplaced-event-capacity.component.scss'],
    standalone: false
})
export class EditUnplacedEventCapacityComponent implements OnInit {

  public form: FormGroup;
  public saving = false;

  public minCapacity = 0;
  public maxCapacity = 0;
  public currentAvailableTickets = 0;
  public unsoldExternalBarcodesCount = 0;
  public soldExternalBarcodesCount = 0;

  private parentId = 0;
  private ticketTypeId: number = null;

  constructor(@Inject(MAT_DIALOG_DATA) public passedData: any,
              public dialogRef: MatDialogRef<EditUnplacedEventCapacityComponent>,
              private loader: HttpLoaderService,
              private eventPlacementService: EventPlacementService,
              private errorHandler: GenericErrorHandler) {
  }

  ngOnInit() {
    this.parentId = this.passedData.parentId;
    this.ticketTypeId = this.passedData.ticketTypeId;
    this.currentAvailableTickets = this.passedData.currentAvailableTickets;
    this.minCapacity = this.passedData.minCapacity;
    this.maxCapacity = this.passedData.maxCapacity;
    this.unsoldExternalBarcodesCount = this.passedData.unsoldExternalBarcodesCount;
    this.soldExternalBarcodesCount = this.passedData.soldExternalBarcodesCount;

    this.form = new FormGroup({
      NrOfTickets: new FormControl(this.currentAvailableTickets, [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
        Validators.min(this.minCapacity),
        Validators.max(this.maxCapacity)
      ])
    });
  }

  get cannotChangeCapacity(): boolean {
    return this.maxCapacity < this.minCapacity;
  }

  submit() {
    if (this.form.invalid || this.cannotChangeCapacity) {
      return;
    }

    const selectedCapacity = Number(this.form.value.NrOfTickets);

    if (selectedCapacity > this.maxCapacity) {
      return;
    }

    this.saving = true;
    this.loader.open();

    this.eventPlacementService.editCapacityForEventPlacement(this.parentId, selectedCapacity, this.ticketTypeId)
      .pipe(finalize(() => {
        this.saving = false;
        this.loader.close();
      }))
      .subscribe({
        next: endpoints => {
          this.dialogRef.close(endpoints);
        },
        error: err => {
          this.errorHandler.handle(err);
        }
      });
  }
}
